const LIST_QUERY = `
  query ListCredentials($paginationParams: PaginationInput!) {
    listCredentials(pagination: $paginationParams) {
      objects {
        name
        uuid
        type
      }
      totalRows
    }
  }
`

const CREATE_MUTATION = `
  mutation CreateCredential(
      $name: String!
      $description: String!
      $url: String!
      $type: CredentialType!
      $rawData: String!
    ) {
    createCredential(params: {
      name: $name
      description: $description
      url: $url
      type: $type
      rawData: $rawData
    }) {
      uuid
      type
    }
  }
`

const DELETE_MUTATION = `
  mutation DeleteCredential($uuid: String!) {
    deleteCredential(uuid: $uuid)
  }
`

const credentialQueries = {
  methods: {
    async listCredentialsQuery(paginationParams) {
      try {
        const result = await this.graphQuery(LIST_QUERY, {paginationParams})
        const {objects: credentialsList, totalRows} = result.listCredentials
        return {credentialsList, totalRows}
      } catch (error) {
        throw new Error(error)
      }
    },
    async createCredentialMutation(data) {
      const _payload = {
        ...data,
        rawData: JSON.stringify(data.rawData),
      }
      try {
        const result = await this.graphQuery(CREATE_MUTATION, _payload)
        return result.createCredential
      } catch (error) {
        throw new Error(error)
      }
    },
    async deleteCredentialMutation(uuid) {
      try {
        const result = await this.graphQuery(DELETE_MUTATION, {uuid})
        return result
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}

export default credentialQueries
